(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
        this.setHeaderHeight = this.setHeaderHeight.bind(this);
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearches = this.querySelectorAll('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        const h = `${this.header.offsetHeight}px`;
        document.documentElement.style.setProperty('--header-height', h);
      }

      disconnectedCallback() {
        this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        const anyOpen = [...this.predictiveSearches].some(
          (predictiveSearch) => predictiveSearch.isOpen
        );
        if (anyOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }

      closeMenuDisclosure() {
        this.disclosures =
          this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        this.searchModals =
          this.searchModals || this.header.querySelectorAll('details-modal');
        this.searchModals.forEach((searchModal) => searchModal.close(false));
      }
    }

    // The account `open` event is composed but does not bubble, so listen during
    // capture. Anchor the dialog to the bottom of the account button itself. The
    // header group can be much taller than the button's row (for example, a
    // top-left logo pushes the menu to a second row), so anchoring to the section
    // bottom drops the dialog too low.
    document.addEventListener(
      'open',
      (event) => {
        if (!(event.target instanceof HTMLElement)) return;
        if (!event.target.matches('shopify-account')) return;

        const rect = event.target.getBoundingClientRect();
        const bottom = Math.max(0, Math.round(rect.bottom));
        event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
      },
      true
    );

    customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();
})();
